import { configureStore, combineReducers } from "@reduxjs/toolkit";

import AuraCameraCommon from "./AuraCamera/common";

import OperationsDetails from "./AuraCamera/operation-details/operations-details";

import Operations from "./AuraCamera/operations/operations.store";
import Sites from "./AuraCamera/sites/sites.store";

const rootReducer = combineReducers({
  AuraCameraCommon: AuraCameraCommon.reducer,
  OperationsDetails: OperationsDetails.reducer,
  Operations: Operations.reducer,
  Sites: Sites.reducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof rootReducer>;

export default store;
